import { apiFetch } from './client';

/**
 * LOS FRENTES Y LOS CHATS.
 *
 * Esteban, 20-sep: *"dividir todo lo que soy de trabajo, todo lo que son
 * personales... ningún frente es más importante que otro, familia es igual de
 * importante a trabajo."*
 */

export interface Frente {
  id: string;
  nombre: string;
  /** Hex. Lo elige el dueño. */
  color: string;
  icono: string | null;
  orden: number;
  /** Pide desbloqueo. Es una casilla, no una jerarquía. */
  conCandado: boolean;
  esPorDefecto: boolean;
  esDemo?: boolean;
  asuntos?: number;
  chats?: number;
}

export interface ChatEnLista {
  id: string;
  nombre: string;
  telefono: string | null;
  contactId: string | null;
  esGrupo: boolean;
  avatarUrl: string | null;
  lastMessageAt: string | null;
  sinLeer: number;
  ultimo: { texto: string; mio: boolean; cuando: string; tipo: string | null } | null;
  /** Un chat puede estar en varios: el primo que además es cliente. */
  frentes: Array<{ id: string; nombre: string; color: string }>;
}

export function getFrentes(): Promise<{ frentes: Frente[] }> {
  return apiFetch('/api/frentes');
}

export function crearFrente(datos: {
  nombre: string;
  color?: string;
  icono?: string;
}): Promise<Frente> {
  return apiFetch('/api/frentes', { method: 'POST', body: datos });
}

export function editarFrente(
  id: string,
  cambios: Partial<Pick<Frente, 'nombre' | 'color' | 'icono' | 'conCandado' | 'orden'>>,
): Promise<Frente> {
  return apiFetch(`/api/frentes/${id}`, { method: 'PATCH', body: cambios });
}

export function borrarFrente(id: string): Promise<{ id: string }> {
  return apiFetch(`/api/frentes/${id}`, { method: 'DELETE' });
}

export function marcarPorDefecto(id: string): Promise<{ id: string }> {
  return apiFetch(`/api/frentes/${id}/por-defecto`, { method: 'POST' });
}

export function getChats(
  filtro: { frenteId?: string; sinFrente?: boolean; buscar?: string; limite?: number } = {},
): Promise<{ chats: ChatEnLista[] }> {
  return apiFetch('/api/chats', { query: filtro });
}

/** Pone o saca un chat de un frente. */
export function moverChatDeFrente(
  conversationId: string,
  frenteId: string,
  poner: boolean,
): Promise<{ conversationId: string; frenteId: string; puesto: boolean }> {
  return apiFetch(`/api/chats/${conversationId}/frentes`, {
    method: 'POST',
    body: { frenteId, poner },
  });
}

export interface MensajeEncontrado {
  mensajeId: string;
  conversationId: string;
  contenido: string;
  cuando: string;
  mio: boolean;
  conQuien: string;
  /** El fragmento con lo buscado entre « », resaltado por Postgres. */
  fragmento: string;
}

/** Busca dentro del texto de los mensajes. Índice GIN en Postgres. */
export function buscarEnMensajes(
  q: string,
  limite = 20,
): Promise<{ mensajes: MensajeEncontrado[] }> {
  return apiFetch('/api/chats/buscar', { query: { q, limite } });
}
